import { useEvgen } from '@funtech-int/yango-shared';

import { useDependencies } from './use-dependencies';
import { createUseEventCallback } from './create-use-event-callback';

export const useEventCallback = createUseEventCallback({ useDependencies, useEvgen });
